import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const PROFESSIONS = [
  'Electricidad', 'Plomería', 'Albañilería', 'Carpintería', 'Pintura',
  'Cerrajería', 'Herrería', 'Refrigeración y Aire Acondicionado',
  'Gasfitería', 'Jardinería', 'Limpieza', 'Fletes y Mudanzas',
  'Mecánica Automotriz', 'Informática y Tecnología', 'Diseño Gráfico',
  'Fotografía', 'Clases y Tutorías', 'Contabilidad', 'Derecho',
  'Salud y Bienestar', 'Belleza y Estética', 'Gastronomía',
  'Construcción', 'Seguridad', 'Otros Servicios',
];

const DEPARTMENTS = [
  'Artigas', 'Canelones', 'Cerro Largo', 'Colonia', 'Durazno',
  'Flores', 'Florida', 'Lavalleja', 'Maldonado', 'Montevideo',
  'Paysandú', 'Río Negro', 'Rivera', 'Rocha', 'Salto',
  'San José', 'Soriano', 'Tacuarembó', 'Treinta y Tres',
];

function Register() {
  const [form, setForm] = useState({
    username: '', email: '', password: '',
    userType: 'BUYER_SELLER', profession: '', department: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.userType === 'PROFESSIONAL' && !form.profession) {
      setError('Seleccioná tu profesión u oficio');
      return;
    }
    setLoading(true);
    try {
      await register(
        form.username, form.email, form.password,
        form.userType, form.profession || null, form.department || null,
      );
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Error al registrarse');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">Crear cuenta</h1>
        <p className="auth-subtitle">Unite al marketplace libertario</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Usuario</label>
            <input
              type="text"
              name="username"
              value={form.username}
              onChange={handleChange}
              required
              minLength={3}
              placeholder="Elegí un nombre de usuario"
              autoComplete="username"
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              placeholder="tu@email.com"
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              required
              minLength={6}
              placeholder="Mínimo 6 caracteres"
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label>¿Cómo vas a usar MercadoLibertario?</label>
            <div className="radio-group">
              <label className={`radio-option ${form.userType === 'BUYER_SELLER' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="userType"
                  value="BUYER_SELLER"
                  checked={form.userType === 'BUYER_SELLER'}
                  onChange={handleChange}
                />
                <span className="radio-icon">🛒</span>
                <span>
                  <strong>Comprar y vender</strong>
                  <small>Publicar artículos y comprar de otros</small>
                </span>
              </label>
              <label className={`radio-option ${form.userType === 'PROFESSIONAL' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="userType"
                  value="PROFESSIONAL"
                  checked={form.userType === 'PROFESSIONAL'}
                  onChange={handleChange}
                />
                <span className="radio-icon">🔧</span>
                <span>
                  <strong>Profesional / Oficio</strong>
                  <small>Ofrecer servicios profesionales</small>
                </span>
              </label>
            </div>
          </div>

          {form.userType === 'PROFESSIONAL' && (
            <div className="form-group">
              <label>Profesión u Oficio *</label>
              <select name="profession" value={form.profession} onChange={handleChange} required>
                <option value="">Seleccioná tu especialidad</option>
                {PROFESSIONS.map((p) => (
                  <option key={p} value={p}>{p}</option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>Departamento (opcional)</label>
            <select name="department" value={form.department} onChange={handleChange}>
              <option value="">Seleccioná tu departamento</option>
              {DEPARTMENTS.map((d) => (
                <option key={d} value={d}>{d}</option>
              ))}
            </select>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button
            type="submit"
            className="btn btn-primary btn-full"
            disabled={loading}
            style={{ marginTop: '0.5rem' }}
          >
            {loading ? <><span className="spinner" /> Registrando...</> : 'Crear cuenta'}
          </button>
        </form>

        <div className="auth-footer">
          ¿Ya tenés cuenta?{' '}
          <Link to="/login">Ingresar</Link>
        </div>
      </div>
    </div>
  );
}

export default Register;
